import { render } from "./UICard.vue?vue&type=template&id=1113ddd4"
import script from "./UICard.vue?vue&type=script&lang=js"
export * from "./UICard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__